module.exports = __webpack_public_path__ + "img/sample.e9031b28.png";